<button class="layout-config-button p-link" type="button" (click)="onExitClick()" pTooltip="Esci"
    tooltipPosition="bottom">
    <i class="pi pi-eject" style="font-size: 1.2rem"></i>
</button>